export const authzServiceName = 'services/authz-gateway';

export const MOCK_WORKSPACE_NAME = 'workspaces/129df398-6d1a-401a-8b07-3583c80d3211';
